class BannerSlider {
  constructor(containerSelector, interval = 4000) {
    this.container = typeof containerSelector === 'string'
      ? document.querySelector(containerSelector)
      : containerSelector;

    if (!this.container) return;

    this.slides = Array.from(this.container.querySelectorAll('.bnnrSlide'));
    if (this.slides.length < 2) return;

    this.current = 0;
    this.interval = interval;
    this.timer = null;

    this.slides[0].classList.add('active');

    this.container.addEventListener('mouseenter', () => this.stop());
    this.container.addEventListener('mouseleave', () => this.start());

    this.start();
  }

  next() {
    const prev = this.current;
    this.current = (this.current + 1) % this.slides.length;

    const incoming = this.slides[this.current];
    const outgoing = this.slides[prev];

    // Position incoming slide off-screen right (no transition yet)
    incoming.classList.add('slideIn');
    incoming.offsetHeight; // force reflow so slideIn position applies

    // Now activate incoming and slide out outgoing
    incoming.classList.remove('slideIn');
    incoming.classList.add('active');

    outgoing.classList.remove('active');
    outgoing.classList.add('slideOut');

    // Clean up after transition
    setTimeout(() => {
      outgoing.classList.remove('slideOut');
    }, 600);
  }

  start() {
    this.timer = setInterval(() => this.next(), this.interval);
  }

  stop() {
    clearInterval(this.timer);
  }
}

export default BannerSlider;
